import { useCallback, useEffect } from "react";
import { spaceActions } from "redux/Ldb/actions/spaceActions";
import { useAppDispatch, useAppSelector } from "../storeHooks";
import { Space } from "redux/Ldb/types/spaceTypes";

const useGetSingleSpace = (
    request: { path: { spaceId: string } },
    options: {
        skip?: boolean;
    } = {}
): useGetSingleSpaceProp => {
    const { path } = request;
    const { skip = false } = options;

    const dispatch = useAppDispatch();

    const {
        fetchingSingleSpace,
        fetchedSingleSpaceSuccess,
        fetchedSingleSpaceFailure,
        removedSpaceMemberSuccess,
        removedSpaceGuestSuccess,
        updatedSpaceSuccess,
        archivedSpaceSuccess,
        unarchivedSpaceSuccess,
    } = useAppSelector((state) => state.space);

    const fetchSingleSpace = () => {
        if (skip) return;
        dispatch(spaceActions.fetchSingleSpace(path.spaceId));
    };

    const resetFetchSingleSpace = useCallback(() => {
        dispatch(spaceActions.resetFetchSingleSpace());
    }, [dispatch]);

    useEffect(() => {
        if (path.spaceId) {
            fetchSingleSpace();
        }
    }, [path?.spaceId]);

    useEffect(() => {
        if (Boolean(removedSpaceMemberSuccess)) {
            fetchSingleSpace();
        }
    }, [removedSpaceMemberSuccess]);

    useEffect(() => {
        if (Boolean(removedSpaceGuestSuccess)) {
            fetchSingleSpace();
        }
    }, [removedSpaceGuestSuccess]);

    useEffect(() => {
        if (Boolean(updatedSpaceSuccess)) {
            fetchSingleSpace();
        }
    }, [updatedSpaceSuccess]);

    useEffect(() => {
        if (Boolean(archivedSpaceSuccess)) {
            fetchSingleSpace();
        }
    }, [archivedSpaceSuccess]);

    useEffect(() => {
        if (Boolean(unarchivedSpaceSuccess)) {
            fetchSingleSpace();
        }
    }, [unarchivedSpaceSuccess]);

    return {
        fetchSingleSpace,
        isSuccess: Boolean(fetchedSingleSpaceSuccess),
        isError: Boolean(fetchedSingleSpaceFailure),
        isLoading: fetchingSingleSpace,
        data: fetchedSingleSpaceSuccess?.data?.space,
        error: fetchedSingleSpaceFailure,
        resetFetchSingleSpace,
    };
};

export default useGetSingleSpace;

type useGetSingleSpaceProp = {
    fetchSingleSpace: () => void;
    isSuccess: boolean;
    isError: boolean;
    isLoading: boolean;
    data: Space;
    error: any;
    resetFetchSingleSpace: () => void;
};
